import { render, staticRenderFns } from "./ProductDetailMovil.vue?vue&type=template&id=bcf24a08&"
import script from "./ProductDetailMovil.vue?vue&type=script&lang=js&"
export * from "./ProductDetailMovil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports